import { Button, Flex, Stack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'

import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ArrowLeft, Edit, Refresh } from '../../icons'
import { OrganizationDetail } from '../../containers/organization/OrganizationDetail'
import { useGetOrganizationUnitById } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { Loading } from '../../components/Loading'
import { useMemo } from 'react'
import { useAuth } from '../../context/AuthContext'
import { PageAlert } from 'brokertslib/src/components'
import { OrganizationDetailHeading } from '../../containers/organization/OrganizationDetailHeading'

export const OrganizationDetailPage = () => {
  const navigate = useNavigate()
  const { organizationUnitId: organizationUnitIdParam } = useParams()
  const organizationUnitId = useMemo(() => Number(organizationUnitIdParam), [organizationUnitIdParam])
  const { data, isLoading, isError, isSuccess, error, refetch } = useGetOrganizationUnitById(organizationUnitId)

  const auth = useAuth()

  return (
    <Section>
      <Container>
        <PageContent>
          {isLoading && <Loading large />}
          {isError && <PageAlert status='error' title={error.request.status === 403 ? 'Přístup odmítnut' : 'Chyba při načítání organizace'}>
            <Stack gap={4}>
              <Button onClick={() => refetch()} colorScheme='secondary'><Refresh /> Načíst znovu</Button>
              <Button onClick={() => navigate(-1)} variant='ghost'><ArrowLeft /> Zpět</Button>
            </Stack>
          </PageAlert>
          }
          {isSuccess && <>
            <PageToolbar
              leftElements={<OrganizationDetailHeading {...data.data} />}
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  {auth?.user?.allowDisplayOrganizationStructure &&
                    <Button variant="ghost" onClick={() => navigate('/organization/list')}>
                      <ArrowLeft color="secondary.500" />
                      Zpět do seznamu organizací
                    </Button>
                  }
                  {auth?.user?.allowEditOrganizationStructure &&
                    <Button colorScheme="primary" onClick={() => navigate('edit')}>
                      <Edit />
                      Upravit organizaci
                    </Button>
                  }
                </Flex>
              }
            />

            <OrganizationDetail organization={data.data} />
          </>}
        </PageContent>
      </Container>
    </Section>
  )
}
